import React from 'react'
import { orderBy, filter, startsWith } from 'lodash'
import { Field } from 'redux-form'
import { TextField, SelectField } from 'redux-form-material-ui'
import { AutoComplete as MUIAutoComplete } from 'material-ui'
import MenuItem from 'material-ui/MenuItem'
import AttributeAutoComplete from './AttributeAutoComplete'
import { required, maxLength, passRegex } from '../../form/validation'

const CategoryFields = ({ category, filterBy = 'form' }) => (
  <div>
    {filter(
      orderBy(category.attributi, 'position'),
      filterBy
    ).map((attributo, i) => {
      const name = `[${i}].${attributo.chiave}`
      const validate = []
      let label = attributo.descrizione
      if (attributo.richiesto) {
        validate.push(required)
        label += ' *'
      }

      if (attributo.autocomplete) {
        return (
          <div key={name}>
            <Field
              maxSearchResults={5}
              validate={validate}
              name={name}
              hintText={label}
              floatingLabelText={label}
              fullWidth={true}
              attributo={attributo.chiave}
              filter={MUIAutoComplete.caseInsensitiveFilter}
              component={AttributeAutoComplete}
            />
            {startsWith(attributo.chiave, 'COSE_') &&
              <p style={{ marginTop: 0, marginBottom: 0 }}>
                <small>
                  * Scrivi una sola parola (o un numero molto limitato di parole) che identifichi in modo generico, ma preciso, la tipologia del tuo oggetto (es. "camicia", "smartphone", "fumetto", "ferro da stiro", etc.).
                </small>
              </p>}
          </div>
        )
      } else if (attributo.tipo === 'enum') {
        const options = attributo.dimensione.split(',')
        return (
          <Field
            fullWidth={true}
            validate={validate}
            key={name}
            name={name}
            hintText={label}
            floatingLabelText={label}
            component={SelectField}>
            {options.map(o => <MenuItem key={o} value={o} primaryText={o} />)}
          </Field>
        )
      } else if (attributo.tipo === 'regex') {
        validate.push(passRegex(attributo.dimensione))
        return (
          <Field
            fullWidth={true}
            validate={validate}
            key={name}
            name={name}
            hintText={label}
            floatingLabelText={label}
            component={TextField}
          />
        )
      } else if (attributo.tipo === 'text') {
        return (
          <Field
            fullWidth={true}
            multiLine={true}
            rows={2}
            validate={validate}
            key={name}
            name={name}
            hintText={label}
            floatingLabelText={label}
            component={TextField}
            helpText={startsWith(attributo.chiave, 'COSE_') ? 'xxx' : undefined}
          />
        )
      } else {
        validate.push(maxLength(attributo.dimensione))
        return (
          <Field
            fullWidth={true}
            validate={validate}
            key={name}
            name={name}
            hintText={label}
            floatingLabelText={label}
            component={TextField}
          />
        )
      }
    })}
  </div>
)

export default CategoryFields



// WEBPACK FOOTER //
// ./src/common/AddItemForm/CategoryFields.js